module.exports = __webpack_public_path__ + "img/hy2.c4b24a3b.png";